import { render } from "./ContaLocal.vue?vue&type=template&id=13873942&scoped=true"
import script from "./ContaLocal.vue?vue&type=script&lang=js"
export * from "./ContaLocal.vue?vue&type=script&lang=js"

import "./ContaLocal.vue?vue&type=style&index=0&id=13873942&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13873942"]])

export default __exports__